module.exports = __webpack_public_path__ + "static/img/c-bg3.33948688.png";